import styled, { css } from 'styled-components';

interface ISkeleton {
  $variant?: 'circle';
  $width?: number | string;
  $height?: number | string;
  $ratio?: number;
}

export const Skeleton = styled.div<ISkeleton>`
  max-width: 100%;
  background-color: var(--c-skeleton);
  border-radius: var(--border-radius);
  overflow: hidden;

  ${({ $width, $height }) => css`
    height: ${$height || '1.5em'};
    width: ${$width || '100%'};
  `}

  ${({ $ratio }) =>
    $ratio &&
    css`
      width: 100%;
      height: 0;
      padding-bottom: ${$ratio * 100}%;
    `}

  ${({ $variant }) =>
    $variant &&
    css`
      ${
        $variant === 'circle' &&
        css`
        border-radius: 50%;
      `
      };
    `}
`;
